import React, { useMemo } from 'react';
import "./Votes.css";
import requestHandler from '../../utils/requestHandler';
import { UserAuth } from '../../context/AuthContext';
import BallotTable from './BallotTable/BallotTable';
import LoadingCircle from '../../components/Global/LoadingCircle';

export default function Votes() {
    const { user } = UserAuth();
    const [ballots, setBallots] = React.useState({ open: [], closed: [] });

    const filteredBallots = useMemo(() => ({
        open: ballots.open,
        closed: ballots.closed
    }), [ballots.open, ballots.closed]);

    React.useEffect(() => {
        if (user) {
            const ballotData = async () => {
                try {
                    if(user.accessToken === undefined)
                        return;

                    const myAuthToken = `Bearer ${user.accessToken}`;
                    const result = await requestHandler("ballot/votable", "GET", myAuthToken);
                    
                    const { open, closed } = result.reduce((acc, ballot) => {
                        if (ballot.closed_at === null) {
                            acc.open.push(ballot);
                        } else {
                            acc.closed.push(ballot);
                        }
                        return acc;
                    }, { open: [], closed: [] });

                    setBallots({ open, closed });
                } catch (error) {
                    console.error("Error fetching ballots:", error);
                }
            };
            ballotData();
        }
    }, [user]);

    return (
        <div>
            <div>
                {ballots.open.length === 0 && ballots.closed.length === 0 && user.isPreviouslyAuthenticated ? 
                    <LoadingCircle /> : 
                    <> 
                        <BallotTable ballots={filteredBallots.open} title="Voturi Deschise" type="opened" />
                        <BallotTable ballots={filteredBallots.closed} title="Voturi Închise Recent" type="closed" /> 
                    </>
                }
            </div>
        </div>
    );
}
